

export const StyleProps: React.CSSProperties = {
    lineHeight: "8px",
}

export const StyleProps1_1: React.CSSProperties ={
    lineHeight: "1.1",
    textAlign: "center"
}

export const StyleProps1: React.CSSProperties ={
    fontSize: "70%",
    lineHeight: "8px",
    textAlign: "left"
}

export const StyleProps2: React.CSSProperties = {
    backgroundColor: "#d9d9f3",
    border: "1px solid black",
    lineHeight: "10px",
    fontSize: "80%",
    textAlign: "left",
    borderCollapse: "collapse"
}

export const StyleProps3: React.CSSProperties = {
    backgroundColor: "#304ACA",
    borderRadius: "1%",
    border: "3px",
    color: "#d9d9f3"
}

export const StyleProps4: React.CSSProperties = {
    backgroundColor: "#ff5100",
    border: "2px inset #001689",
    color:"white",
    lineHeight: "1"
}

export const StyleProps5: React.CSSProperties = {
    backgroundColor: "#d9d9f3",
    border: "1px solid black",
    lineHeight: "10px",
    color: "#000",
    fontSize: "80%",
    textAlign: "left"
}


export const StyleProps6: React.CSSProperties = {
    color: "#d9d9f3",
    fontSize: "70%",
    lineHeight: "0",
}


export const StyleProps7: React.CSSProperties = {
    backgroundColor:"#304ACA",
    lineHeight: "0",
    border:"2px solid black",
    borderCollapse: "separate"
}


export const StyleProps8: React.CSSProperties = {
    border: "2px solid black",
    lineHeight: "0.95"
}


export const StyleProps9 : React.CSSProperties = {
    backgroundColor:"#d9d9f3",
    lineHeight:"0",
    textAlign: "center",
    border: "1px solid black"
}

export const StyleProps10: React.CSSProperties = {
    backgroundColor:"#ff5100",
    textAlign: "left",
    color:"white",
    padding: "0 4px",
    border: "1px solid black"

}

export const StyleProps11: React.CSSProperties = {
    backgroundColor:"#ff5100",
    textAlign: "right",
    color:"white",
    padding: "0 4px",
    border: "1px solid black"

}

export const StyleProps12: React.CSSProperties = {
    border:"1px solid black",
    borderCollapse: "separate",
}

export const StyleProps13: React.CSSProperties = {
    fontSize: "70%",
    lineHeight: "0.8",
    color: "#d9d9f3"
}

export const StyleProps14: React.CSSProperties ={
    border:"1px solid black",
    borderCollapse:"separate",
    color: "black"
}


export const StyleProps15: React.CSSProperties = {
    fontSize: "70%"
}

export const StyleProps16: React.CSSProperties = {
    fontSize: "70%",
    lineHeight: "0.8"
}